<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section class="users-list-wrapper">
            <app-brand-model-list></app-brand-model-list>
        </section>
    </div>
</div>